"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ChangeEmrInstanceStatusRequestSchema () {
        return ChangeEmrInstanceStatusRequestSchema;
    },
    get ChangeEmrInstanceStatusResponseSchema () {
        return ChangeEmrInstanceStatusResponseSchema;
    },
    get EMR_INSTANCE_ERROR_CODES () {
        return EMR_INSTANCE_ERROR_CODES;
    },
    get EMR_INSTANCE_KEY_STATUSES () {
        return EMR_INSTANCE_KEY_STATUSES;
    },
    get EMR_INSTANCE_MAX_LIVE_KEYS () {
        return EMR_INSTANCE_MAX_LIVE_KEYS;
    },
    get EMR_INSTANCE_NAME_MAX_LENGTH () {
        return EMR_INSTANCE_NAME_MAX_LENGTH;
    },
    get EMR_INSTANCE_STATUSES () {
        return EMR_INSTANCE_STATUSES;
    },
    get EmrInstanceKeyListResponseSchema () {
        return EmrInstanceKeyListResponseSchema;
    },
    get EmrInstanceKeySchema () {
        return EmrInstanceKeySchema;
    },
    get EmrInstanceListResponseSchema () {
        return EmrInstanceListResponseSchema;
    },
    get EmrInstanceSchema () {
        return EmrInstanceSchema;
    },
    get IssueEmrInstanceKeyRequestSchema () {
        return IssueEmrInstanceKeyRequestSchema;
    },
    get IssueEmrInstanceKeyResponseSchema () {
        return IssueEmrInstanceKeyResponseSchema;
    },
    get RegisterEmrInstanceRequestSchema () {
        return RegisterEmrInstanceRequestSchema;
    },
    get RegisterEmrInstanceResponseSchema () {
        return RegisterEmrInstanceResponseSchema;
    }
});
const _zod = require("zod");
const EMR_INSTANCE_STATUSES = [
    'active',
    'disabled'
];
const EMR_INSTANCE_KEY_STATUSES = [
    'live',
    'expired',
    'revoked'
];
const EMR_INSTANCE_NAME_MAX_LENGTH = 200;
const EMR_INSTANCE_MAX_LIVE_KEYS = 3;
const EMR_INSTANCE_ERROR_CODES = {
    /** `409` on register or enable: the clinic is suspended. */ tenantSuspended: 'EMR_INSTANCE_TENANT_SUSPENDED',
    /** `409` on register or enable: the tenant is the platform, or not marked as a clinic. */ notAClinic: 'EMR_INSTANCE_NOT_A_CLINIC',
    /**
   * `409` on revoke: this is the instance's only live key. Issue a new key
   * first, or disable the instance to stop the EMR.
   */ lastLiveKey: 'EMR_LAST_LIVE_KEY',
    /** `409` on issue: the instance already has three live keys. Revoke one first. */ keyLimitReached: 'EMR_KEY_LIMIT_REACHED'
};
const INSTANCE_ID = _zod.z.string().regex(/^[a-z0-9-]{1,64}$/);
const KEY_ID = _zod.z.string().regex(/^[a-z0-9-]{1,32}$/);
/** `{instanceId}.{keyId}.{secret}`, the secret 32 bytes as base64url with no padding. */ const SIGNING_KEY = _zod.z.string().regex(/^[a-z0-9-]{1,64}\.[a-z0-9-]{1,32}\.[A-Za-z0-9_-]{43}$/);
const EmrInstanceSchema = _zod.z.object({
    /** The row id. */ id: _zod.z.uuid(),
    /** The id the EMR signs with, and the `:instanceId` of the routes. */ instanceId: INSTANCE_ID,
    name: _zod.z.string(),
    status: _zod.z.enum(EMR_INSTANCE_STATUSES),
    /** The highest payload version the EMR supports. */ maxVersion: _zod.z.string(),
    /** The EMR's last verified request. Null until it first checks in. */ lastSeenAt: _zod.z.iso.datetime().nullable(),
    /** A summary of the instance's keys. `GET .../keys` lists them. */ keys: _zod.z.object({
        /** Keys that can sign now. 0 means the EMR can't connect until a key is issued. */ live: _zod.z.number().int().min(0),
        /** The latest use of any of its keys. Null until a key signs. */ lastUsedAt: _zod.z.iso.datetime().nullable()
    }).strict(),
    createdAt: _zod.z.iso.datetime(),
    updatedAt: _zod.z.iso.datetime()
}).strict();
const EmrInstanceListResponseSchema = _zod.z.object({
    items: _zod.z.array(EmrInstanceSchema)
}).strict();
const EmrInstanceKeySchema = _zod.z.object({
    keyId: KEY_ID,
    status: _zod.z.enum(EMR_INSTANCE_KEY_STATUSES),
    createdAt: _zod.z.iso.datetime(),
    /**
     * The last signed request with this key. Recorded at most once a minute
     * per key, so it can lag by up to a minute. Null until it first signs.
     */ lastUsedAt: _zod.z.iso.datetime().nullable(),
    /** When it stops working on its own. Null means it works until revoked. */ expiresAt: _zod.z.iso.datetime().nullable(),
    revokedAt: _zod.z.iso.datetime().nullable()
}).strict();
const EmrInstanceKeyListResponseSchema = _zod.z.object({
    items: _zod.z.array(EmrInstanceKeySchema)
}).strict();
const RegisterEmrInstanceRequestSchema = _zod.z.object({
    name: _zod.z.string().trim().min(1).max(EMR_INSTANCE_NAME_MAX_LENGTH)// eslint-disable-next-line no-control-regex -- the point is to reject control characters
    .regex(/^[^\u0000-\u001f\u007f]*$/, 'must not contain control characters')
}).strict();
const RegisterEmrInstanceResponseSchema = _zod.z.object({
    instanceId: INSTANCE_ID,
    keyId: KEY_ID,
    signingKey: SIGNING_KEY
}).strict();
const IssueEmrInstanceKeyRequestSchema = _zod.z.object({
    expiresAt: _zod.z.iso.datetime({
        offset: true
    }).nullable().optional()
}).strict();
const IssueEmrInstanceKeyResponseSchema = _zod.z.object({
    keyId: KEY_ID,
    signingKey: SIGNING_KEY
}).strict();
const ChangeEmrInstanceStatusRequestSchema = _zod.z.object({
    status: _zod.z.enum(EMR_INSTANCE_STATUSES)
}).strict();
const ChangeEmrInstanceStatusResponseSchema = _zod.z.object({
    instance: EmrInstanceSchema
}).strict();
